export default "__VITE_ASSET__CGKgOKxE__"